module.exports = __webpack_public_path__ + "bg-15.png?807d1e5d2993be0ddd3e664f9cc07b90";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg-15.png
// module id = 70
// module chunks = 0